import React from 'react';
import BrandPage from './BrandPage';

const AquatechPage = () => <BrandPage brandSlug="aquatech" />;

export default AquatechPage;
